/**
 * ExecuteButton.js
 * description: Renders button execute button and initializes execution
 */

/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useRef } from "react";
import { useHotkeys } from "react-hotkeys-hook";

import { Button, Tooltip } from "@chakra-ui/react";
import { css } from "@emotion/react";

import { context } from "../context/GlobalState";
const ExecuteButton = () => {
  const { state, dispatch } = useContext(context);

  // KEYBOARD SHORTCUT: CTRL+ENTER
  const buttonRef = useRef(null);
  useHotkeys("ctrl+enter", () => {
    buttonRef.current.click();
  });

  const handleClick = () => {
    // Catch if executing with empty editorCode
    if (!state.editorCode) {
    }
    dispatch({ type: "SET_SOURCE_CODE", payload: state.editorCode });
  };

  return (
    <Tooltip label="Ctrl + Enter">
      <Button
        css={css`
          :hover {
            color: #172b3a;
            background-color: #fff;
            border-color: #172b3a;
          }
        `}
        mr={2}
        bg="#172b3a"
        border="1px"
        borderColor="white"
        ref={buttonRef}
        onClick={handleClick}
      >
        RUN
      </Button>
    </Tooltip>
  ); //everytime ExecuteButton is clicked, call handleClick function
};

export default ExecuteButton;
